module.exports = __webpack_public_path__ + "4a2729605de36897ce86c45d9c2b2473.pdf";